const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Rebellion extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Rebellion,
            "Each civlization immediately spends 2 civil actions (without effect) per discontent worker.",
            {}
        )
    }
}

module.exports = Rebellion;